import React from 'react';
import { Link } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center vh-100 text-center p-4">
          <h1 className="display-4 text-danger">Something went wrong 😢</h1>
          <p className="lead">{this.state.error?.message || 'An unexpected error occurred.'}</p>
          <div className="mt-3">
            <button className="btn btn-primary me-2" onClick={this.handleRetry}>
              Retry
            </button>
            <Link to="/dashboard" className="btn btn-outline-secondary">
              Go Home
            </Link>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
